import { Injectable, HostListener } from '@angular/core';
import {HttpClient,HttpParams,HttpHeaders} from "@angular/common/http";
import { from, Observable } from 'rxjs';


import { FormGroup } from '@angular/forms';

import { retry, catchError } from 'rxjs/operators';
import { GlobalService } from 'src/app/global.service';
import { GetQuote } from '../Models/getQuote';
import { riskModel } from '../Models/riskModel';
import { debug } from 'util';
import { PrintSchedule } from 'src/app/Modules/listing/Models/PrintSchedule';
//import { runInThisContext } from 'vm';



@Injectable({providedIn:"root"})
export class QuoteService {
  

  constructor(private http:HttpClient,private global:GlobalService) {

   }
   
  public getQuoteService(quoteDetails){
      //alert("servicess"+this.global.Baseurl +"data"+JSON.stringify(quoteDetails));
      
      console.log(this.global.Baseurl+this.global.motorquoterouting);//http://10.44.11.92:8096/NICMobility/quote
    return this.http.post(this.global.Baseurl+this.global.motorquoterouting,quoteDetails);
  }
  public calculatePremiumService(riskDetails){
    
    //alert("servicess"+this.global.Baseurl +"data"+JSON.stringify(quoteDetails));
  
    console.log(this.global.Baseurl+this.global.calculatePremiumrouting);//http://10.44.11.92:8096/NICMobility/quote
  return this.http.post(this.global.Baseurl+this.global.calculatePremiumRouting,riskDetails);
}
public getCustomerDetails(nicNo,custCategory){
 
//  alert("servicess"+nicNo);
  console.log(this.global.Baseurl+this.global.calculatePremiumrouting);//http://10.44.11.92:8096/NICMobility/quote
return this.http.get(this.global.Baseurl+this.global.getCustomerDetailsRouting+nicNo+"/"+custCategory);
}
public idvValidation(risk:riskModel){
  
  return this.http.post(this.global.Baseurl+this.global.idvValidationRouting,risk);
}
public convertToProposal(quoteNo,appFlag,emailid,name,agentemail){
  
  console.log("Full URL: ", this.global.Baseurl+this.global.convertToProposalRouting+"?quoteNo="+quoteNo+"&&appFlag="+appFlag);
  return this.http.get(this.global.Baseurl+this.global.convertToProposalRouting+"?quoteNo="+quoteNo+"&&appFlag="+appFlag+"&&emailid="+emailid+"&&name="+name+"&&agentemail="+agentemail);
}
public regValidation(regVal){
  console.log(this.global.Baseurl+this.global.regValidationrouting);
  return this.http.get(this.global.Baseurl+this.global.regValidationrouting+"/"+regVal);
}
  
public chassisValidation(chassisVal){
  console.log(this.global.Baseurl+this.global.chassisValidationrouting);
  return this.http.get(this.global.Baseurl+this.global.chassisValidationrouting+"/"+chassisVal);
}

public engValidation(engVal){
  console.log(this.global.Baseurl+this.global.engValidationrouting);
  return this.http.get(this.global.Baseurl+this.global.engValidationrouting+"/"+engVal);
}

public getQuoteDetails(quoteNo){
  
 
  return this.http.get(this.global.Baseurl+this.global.getQuoteDetailsRouting+"?quoteNo="+quoteNo);
}
  
public submitToUnderwitter(quoteNo,emailid,name,agentemail){
  
  return this.http.get(this.global.Baseurl+this.global.submitToUnderWritterRouting+"?quoteNo="+quoteNo+"&&emailid="+emailid+"&&name="+name+"&&agentemail="+agentemail);
}
public printSchedule(quoteno,printList,agentEmail,agentName,data){
  
  var name;
  agentEmail=null;
  var emailid=null;
  for(let i=0;i<printList.length;i++){
    if(i==0){
    name=printList[i].repId;
    }
    else{
      name=name+","+printList[i].repId;

    }
  }
  return this.http.get(this.global.Baseurl+this.global.printscheduleRouting+"/"+agentName+"/"+agentEmail+"/"+emailid+"/"+data+"?quoteNo="+quoteno+"&&printList="+name);
}
public sendMailPrintSchedule(quoteno,printList,agentEmail,agentName,emailid,data){
  
  var name;
  for(let i=0;i<printList.length;i++){
    if(i==0){
    name=printList[i].repId;
    }
    else{
      name=name+","+printList[i].repId;

    }
  }
  return this.http.get(this.global.Baseurl+this.global.printscheduleRouting+"/"+agentName+"/"+agentEmail+"/"+emailid+"/"+data+"?quoteNo="+quoteno+"&&printList="+name);
}

public getPremiumComputationSheet(quoteNo){
  return this.http.get(this.global.Baseurl+this.global.premiumComputationSheet+"?quoteNo="+quoteNo);
}
public getCoverDetails(quoteno){
  return this.http.get(this.global.Baseurl+this.global.coverDeailsRouting+"?quoteNo="+quoteno);
}
public saveAddOnCovers(addCoverDetails){
  return this.http.post(this.global.Baseurl+this.global.addOnCoversRouting,addCoverDetails);
}
public reCalculate(quoteNo){
  return this.http.get(this.global.Baseurl+this.global.reCalculateRouting+"?quoteNo="+quoteNo);
}
public editQuoteDetails(quoteNo){
  return this.http.get(this.global.Baseurl+this.global.editQuoteDetailsRouting+"?quoteNo="+quoteNo);
}
requestPolicy(quoteNo,emailid,name,pageName,agentemail){
  return this.http.get(this.global.Baseurl+this.global.requestPolicyrouting+"?quoteNo="+quoteNo+"&&emailid="+emailid+"&&name="+name+"&&pageName="+pageName+"&&agentemail="+agentemail);

}
getScheduleDetails(quoteNo){
  return this.http.get(this.global.Baseurl+this.global.getScheduleDetails+"?quoteNo="+quoteNo);

}
  
  
public getQuoteDetailstravel(quoteNo){
  
 
  return this.http.get(this.global.Baseurl+this.global.getQuoteDetailstravel+"?quoteNo="+quoteNo);
} 
//addoncover for travel product
public getCoverdetails(quoteno,riskNo){
  return this.http.get(this.global.Baseurl+this.global.coverlistrouting+"?quoteNo="+quoteno+"&&riskNo="+riskNo);
}

public installbreakup(quoteNo){
  
  return this.http.get(this.global.Baseurl+this.global.installmentrouting+"?quoteNo="+quoteNo);
}

public getLockQuoteDetails(quoteNo,userName){
  
  return this.http.get(this.global.Baseurl+this.global.LockQuoteDetails+"?quoteNo="+quoteNo+"&&userName="+userName);
}

public unlockQuotedetails(userName){

return this.http.get(this.global.Baseurl+this.global.unlockQuote+"?userName="+userName);

}

public deleteStdPolicyDtls(RHsysid){
  
  return this.http.get(this.global.Baseurl+this.global.deleteStdPolicyDtls+"?RHsysid="+RHsysid);

}

public gettransactiondetails(quoteNo){
  
  return this.http.get(this.global.Baseurl+this.global.transactionDetails+"?quoteNo="+quoteNo);
}

public getheaderdetails(quoteNo){
  
  return this.http.get(this.global.Baseurl+this.global.getheaderdetails+"?quoteNo="+quoteNo); 
}

public getPolicydetails(RHsysid){
  
  return this.http.get(this.global.Baseurl+this.global.policyDetails+"?RHsysid="+RHsysid);
}

public insertpaymentDetails(obj){
  
  return this.http.post(this.global.Baseurl+this.global.insertpaymentDetails,obj);
}

public getreceiptdetails(RHsysid){
  
  return this.http.get(this.global.Baseurl+this.global.receiptDetails+"?RHsysid="+RHsysid);
}

public getapprovalmatrixdetail(quoteNo){
  
  return this.http.get(this.global.Baseurl+this.global.approvalmatrixDetails+"?quoteNo="+quoteNo); 
}

public updateQuoteToPolNo(polNo){
  
  return this.http.get(this.global.Baseurl+this.global.updateQuoteToPolNo+"?polNo="+polNo);
}

public exceptionDetails(obj){
  
  return this.http.post(this.global.Baseurl+this.global.exceptionDetails,obj);

}
public updateExceptionDtls(obj){
  
  return this.http.post(this.global.Baseurl+this.global.updateExceptionDtls,obj);

}

public getExceptionStatus(quoteNumber){
  
  return this.http.get(this.global.Baseurl+this.global.getExceptionStatus+"?quoteNo="+quoteNumber);
 
}
public getNoofdays(obj){
  
  return this.http.post(this.global.Baseurl+this.global.getNoofdays,obj);

}

public vehicleValidation(quoteNo){
  
  return this.http.get(this.global.Baseurl+this.global.vehicleValidation+"?quotNo="+quoteNo);
 
}
public getInstlType(result){
  
  return this.http.get(this.global.Baseurl+this.global.getInstlType+"?result="+result); 
}

public saveProposalDtls(obj){
  
  return this.http.post(this.global.Baseurl+this.global.saveProposalDtls,obj); 
}
public getProposaldtls(quoteNo){
  
  return this.http.get(this.global.Baseurl+this.global.getProposaldtls+"?quoteNo="+quoteNo); 
}

public getQuestions(){
  
  return this.http.get(this.global.Baseurl+this.global.getQuestions);  
}

public submitQuestion(obj){
  
  return this.http.post(this.global.Baseurl+this.global.submitQuestion,obj);  
 
}
public getQuestionsData(quoteNo){
  
  return this.http.get(this.global.Baseurl+this.global.getQuestionsData+"?quoteNo="+quoteNo);  
  
}
/// Medical //////////////
public getPrintData(receiptNo){
  return this.http.get(this.global.Baseurl+this.global.receiptPrint+"?receiptNo="+receiptNo); 
}


}